import {ISimplePresentation, ISimplePresentationRunnerController} from "../SimplePresentationRunner";
import {Game} from "../Game";
import {GameModeNames} from "../server/GameModeNames";
import {gsap} from "gsap";
import {IMonster, MONSTER_WEAPON_ACTIONS} from "../server/IData";
import {MonsterSymbol} from "../reels/MonsterSymbol";
import { MathHelper } from "@nolimitcity/slot-game/bin/utils/MathHelper";

export class TankBoostersRunner implements ISimplePresentation {

    public shouldRun(): boolean {
        return Game.isBoostedBetItems();
    }

    public start(controller: ISimplePresentationRunnerController): void {
        const featureTl: gsap.core.Timeline = gsap.timeline({
                onComplete: () => {
                    controller.finish();
                }
            }),
            monsters: IMonster[] = Game.model.gameData.monsters,
            reels: string[][] = Game.model.gameData.reels;
        let monstersCount: number = 0;

        featureTl.add(() => {
            controller.setSkipCallback(() => {
                this.onSkip(featureTl);
            });
        });

        for (let i: number = 0; i < Game.DEFAULT_REELS_NUM; i++) {
            for (let j: number = Game.DEFAULT_ROWS_NUM - 1; j > -1; j--) {
                if (Game.MONSTER_SYMBOLS.includes(reels[i][j])) {
                    const monIdx: number = Game.MONSTER_NAME_TO_IDX[reels[i][j]],
                        monster: IMonster = this.getRespectiveMonsterData(monsters, monIdx),
                        carriedSymbols: string[] = monster.carriedSymbols,
                        monsterSymbol: MonsterSymbol = Game.reelsView.reelModels[i].getMonsterSymbolAt(monster.symbol),
                        tl: gsap.core.Timeline = gsap.timeline();

                    carriedSymbols.forEach((weapon: string, idx: number) => {
                        if (weapon === "AS") {
                            tl.add(monsterSymbol.getStateAnimation(MONSTER_WEAPON_ACTIONS.TANK_BOOSTER_AS, 5));
                        } else if (weapon === "BU") {
                            tl.add(monsterSymbol.getStateAnimation(MONSTER_WEAPON_ACTIONS.TANK_BOOSTER_BU, 5));
                        } else if (weapon === "BZ") {
                            tl.add(monsterSymbol.getStateAnimation(MONSTER_WEAPON_ACTIONS.TANK_BOOSTER_BZ, 5));
                        } else if (weapon === "GR") {
                            tl.add(monsterSymbol.getStateAnimation(MONSTER_WEAPON_ACTIONS.TANK_BOOSTER_GR, 5));
                        }

                        tl.add(()=>{
                            Game.soundPlayer.playSound("boosterSpawnPickup" + MathHelper.randomIntInRange(1,4), 1);
                        }, "<0.438");

                        tl.add(monsterSymbol.addWeaponFlag(weapon.toLowerCase()), "<");
                    });

                    tl.add(() => {
                        Game.soundPlayer.playSound("boosterSpawn" + MathHelper.randomIntInRange(1,2), 1)
                    }, "<");

                    featureTl.add(tl, 0.1 * monstersCount);

                    monstersCount++;
                    if (monstersCount === Game.MONSTER_SYMBOLS.length) {
                        break;
                    }
                }
            }

            if (monstersCount === Game.MONSTER_SYMBOLS.length) {
                break;
            }
        }
    }

    private onSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }

    private getRespectiveMonsterData(monsters: IMonster[], idx: number): IMonster {
        for (let i: number = 0; i < monsters.length; i++) {
            if ((monsters[i].symbol - Game.MONSTER_SYMBOLS.length) === idx) {
                return monsters[i];
            }
        }

        return monsters[idx];
    }
}